import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconBeleta from '../build/icon-beleta'

export const IconBeleta: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconBeleta} />
}

export default IconBeleta
